<template lang='pug'>
  i.svg-icon.svg-icon-close
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M50.009,1.674c-26.933,0-48.845,21.785-48.845,48.559c0,26.777,21.912,48.561,48.845,48.561 c26.932,0,48.843-21.783,48.843-48.561C98.852,23.459,76.94,1.674,50.009,1.674z M69.763,64.152c0.795,0.788,0.795,2.068,0,2.86 l-2.878,2.861c-0.795,0.791-2.082,0.791-2.877,0L50.009,55.956l-14,13.918c-0.795,0.791-2.084,0.791-2.878,0l-2.877-2.861 c-0.796-0.792-0.796-2.072,0-2.86l13.999-13.92L30.253,36.315c-0.796-0.79-0.796-2.071,0-2.861l2.877-2.861 c0.794-0.79,2.083-0.79,2.878,0l14,13.918l13.999-13.918c0.795-0.79,2.082-0.79,2.877,0l2.878,2.861 c0.796,0.79,0.796,2.071,0,2.861L55.765,50.232L69.763,64.152z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
  
}
</script>